import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CreditCard, Users, Star } from 'lucide-react';
export const Hero = () => {
  return <section className="relative bg-navy text-white pt-10 pb-12 md:pt-16 md:pb-20 overflow-hidden" data-id="element-153">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_var(--tw-gradient-stops))] from-navy-light via-navy to-navy opacity-80" data-id="element-154"></div>

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center" data-id="element-155">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="space-y-5 md:space-y-7" data-id="element-156">
          <div className="inline-block bg-teal/20 text-teal-light font-semibold px-3 py-1 rounded-full text-xs md:text-sm border border-teal/30" data-id="element-157">
            Sistema Clínico TO · Argentina
          </div>

          {/* H1 Main Title */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.1] tracking-tight" data-id="element-158">
            Todo tu año de <br className="hidden sm:block" data-id="element-159" />
            <span className="text-gold" data-id="element-160">Práctica Domiciliaria</span>{' '}
            <br className="hidden sm:block" data-id="element-161" />
            Resuelto
          </h1>

          {/* Mockup image at ~70% */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative max-w-[70%] mx-auto pt-2" data-id="element-162">
            <div className="absolute inset-0 bg-gold/20 blur-[80px] rounded-full" data-id="element-163"></div>
            <img src="https://cdn.magicpatterns.com/uploads/95sLKdPThf7dRpT4oNdUhY/Mockup_TO_AUTONOMIA_TOTAL.png" alt="Megapack TO Autonomía Total - 6 Tomos y 6 Bonos clínicos" loading="eager" decoding="async" fetchPriority="high" width={1024} height={1024} className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-164" />
          </motion.div>

          {/* Small product structure descriptor */}

          {/* Subtitle */}
          <p className="text-base md:text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto" data-id="element-165">
            Tu sistema clínico completo para devolver independencia a pacientes
            con Parkinson: evaluación, AVD, entorno, familia, seguimiento y
            cognición.{' '}
            <strong className="text-white" data-id="element-166">
              Sin improvisar en el domicilio.
            </strong>
          </p>

          {/* CTA */}
          <div className="space-y-3 pt-2" data-id="element-167">
            <a href="#pricing" className="inline-block w-full sm:w-auto text-center bg-gold hover:bg-gold-light text-navy font-extrabold text-base md:text-lg py-3.5 md:py-4 px-6 md:px-10 rounded-lg shadow-[0_0_20px_rgba(212,162,76,0.4)] transition-all transform hover:-translate-y-1 active:scale-95" data-id="element-168">
              💥 QUIERO MI PRÁCTICA RESUELTA AHORA
            </a>
            <p className="text-xs md:text-sm text-gray-400" data-id="element-169">
              PDF Digital · Acceso Inmediato · TO Independiente
            </p>
          </div>

          {/* Trust badges */}
          <div className="grid grid-cols-4 gap-2 md:gap-4 pt-4 md:pt-6 border-t border-white/10 max-w-2xl mx-auto" data-id="element-170">
            <div className="flex flex-col items-center gap-1" data-id="element-171">
              <ShieldCheck className="w-4 h-4 md:w-5 md:h-5 text-teal-light" data-id="element-172" />
              <span className="text-[10px] md:text-xs text-gray-300 font-medium text-center leading-tight" data-id="element-173">
                Garantía
                <br data-id="element-174" />7 días
              </span>
            </div>
            <div className="flex flex-col items-center gap-1" data-id="element-175">
              <CreditCard className="w-4 h-4 md:w-5 md:h-5 text-teal-light" data-id="element-176" />
              <span className="text-[10px] md:text-xs text-gray-300 font-medium text-center leading-tight" data-id="element-177">
                Mercado
                <br data-id="element-178" />
                Pago
              </span>
            </div>
            <div className="flex flex-col items-center gap-1" data-id="element-179">
              <Users className="w-4 h-4 md:w-5 md:h-5 text-teal-light" data-id="element-180" />
              <span className="text-[10px] md:text-xs text-gray-300 font-medium text-center leading-tight" data-id="element-181">
                +500
                <br data-id="element-182" />
                TOs
              </span>
            </div>
            <div className="flex flex-col items-center gap-1" data-id="element-183">
              <div className="flex text-gold" data-id="element-184">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 md:w-4 md:h-4 fill-current" data-id="element-185" />)}
              </div>
              <span className="text-[10px] md:text-xs text-gray-300 font-medium text-center leading-tight" data-id="element-186">
                4.9
                <br data-id="element-187" />
                Rating
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};